const QUICK_ACTION_MENU_MODES = Object.freeze({
  REMOVE: 'REMOVE',
  ADD_USER: 'ADD_USER',
  ADD_USERS: 'ADD_USERS',
});

const QUICK_ACTION_MENU_STEP = {
  CONFIRM: 'CONFIRM',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

const QUICK_ACTION_MENU_CONFIG = Object.freeze({
  [QUICK_ACTION_MENU_MODES.REMOVE]: {
    [QUICK_ACTION_MENU_STEP.CONFIRM]: {
      title: 'soho_plans_remove_user_quick_action_title',
      description: 'soho_plans_remove_user_quick_action_description',
      confirmButtonTitle: 'soho_plans_remove_user_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_plans_remove_user_quick_action_cancel_button_title',
    },
    [QUICK_ACTION_MENU_STEP.LOADING]: {
      subTitle: 'soho_plans_remove_user_loading_modal_description',
    },
    [QUICK_ACTION_MENU_STEP.SUCCESS]: {
      title: 'soho_plans_remove_user_success_modal_title',
      description: 'soho_plans_remove_user_success_modal_plan_name_description',
      primaryButtonProps: {
        title: 'soho_plans_add_users_success_modal_return_to_plans',
      },
      secondaryButtonProps: {
        title: 'soho_plans_add_users_success_modal_return_to_business_overview',
      },
    },
    [QUICK_ACTION_MENU_STEP.FAILURE]: {
      title: 'soho_plans_add_or_remove_user_failure_modal_title',
      primaryButtonProps: {
        title: 'soho_plans_add_or_remove_user_failure_modal_try_again',
      },
      secondaryButtonProps: {
        title: 'soho_plans_add_or_remove_user_failure_modal_close',
      },
    },
  },
  [QUICK_ACTION_MENU_MODES.ADD_USER]: {
    [QUICK_ACTION_MENU_STEP.CONFIRM]: {
      title: 'soho_plans_add_user_quick_action_title',
      description: 'soho_plans_add_user_quick_action_description',
      confirmButtonTitle: 'soho_plans_add_user_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_plans_add_user_quick_action_cancel_button_title',
    },
    [QUICK_ACTION_MENU_STEP.LOADING]: {
      subTitle: 'soho_plans_add_users_loading_modal_description',
    },
    [QUICK_ACTION_MENU_STEP.SUCCESS]: {
      title: 'soho_plans_add_users_success_modal_title',
      description: 'soho_plans_add_user_success_modal_plan_name_description',
      primaryButtonProps: {
        title: 'soho_plans_add_users_success_modal_return_to_plans',
      },
    },
    [QUICK_ACTION_MENU_STEP.FAILURE]: {
      title: 'soho_plans_add_or_remove_user_failure_modal_title',
      primaryButtonProps: {
        title: 'soho_plans_add_or_remove_user_failure_modal_try_again',
      },
      secondaryButtonProps: {
        title: 'soho_plans_add_or_remove_user_failure_modal_close',
      },
    },
  },
  [QUICK_ACTION_MENU_MODES.ADD_USERS]: {
    [QUICK_ACTION_MENU_STEP.CONFIRM]: {
      title: 'soho_plans_add_users_quick_action_title',
      description: 'soho_plans_add_users_quick_action_description',
      confirmButtonTitle: 'soho_plans_add_user_quick_action_confirm_button_title',
      cancelButtonTitle: 'soho_plans_add_user_quick_action_cancel_button_title',
    },
    [QUICK_ACTION_MENU_STEP.LOADING]: {
      subTitle: 'soho_plans_add_users_loading_modal_description',
    },
    [QUICK_ACTION_MENU_STEP.SUCCESS]: {
      title: 'soho_plans_add_users_success_modal_title',
      description: 'soho_plans_add_users_success_modal_plan_name_description',
      primaryButtonProps: {
        title: 'soho_plans_add_users_success_modal_return_to_plans',
      },
    },
    [QUICK_ACTION_MENU_STEP.FAILURE]: {
      title: 'soho_plans_add_or_remove_user_failure_modal_title',
      primaryButtonProps: {
        title: 'soho_plans_add_or_remove_user_failure_modal_try_again',
      },
      secondaryButtonProps: {
        title: 'soho_plans_add_or_remove_user_failure_modal_close',
      },
    },
  },
});

export { QUICK_ACTION_MENU_MODES, QUICK_ACTION_MENU_CONFIG, QUICK_ACTION_MENU_STEP };
